import { createActions } from 'redux-actions';

export const { handleDebt, clearDebt, handleDebtEditing } = createActions({
    handleDebt: (debt) => debt,
    clearDebt: () => ({}),
    handleDebtEditing: (editing) => editing,
});
